"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** Bootstrap progress bar with adjusted percentage colors. It will show right even small numbers */
var CccisdProgressBar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CccisdProgressBar, _React$Component);

  function CccisdProgressBar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CccisdProgressBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CccisdProgressBar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      width: 0
    });

    return _this;
  }

  _createClass(CccisdProgressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // we need actual width of the progress bar
      this.setState({
        width: this.progress.scrollWidth
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var percentage = this.props.percentage;
      return _react.default.createElement("div", {
        className: "progress ".concat(_style.default.progress),
        ref: function ref(elem) {
          _this2.progress = elem;
        }
      }, _react.default.createElement("div", {
        className: _style.default.progressPercent
      }, percentage, "%"), _react.default.createElement("div", {
        className: "progress-bar ".concat(_style.default.progressBar),
        style: {
          width: "".concat(percentage, "%")
        }
      }, _react.default.createElement("div", {
        className: _style.default.progressBarPercent,
        style: {
          width: "".concat(this.state.width, "px")
        }
      }, percentage, "%")));
    }
  }]);

  return CccisdProgressBar;
}(_react.default.Component);

exports.default = CccisdProgressBar;

_defineProperty(CccisdProgressBar, "propTypes", {
  /** Percentage */
  percentage: _propTypes.default.number.isRequired
});